export const tags = {
  en: [
    {
      label: "DEI",
      url_slug: "dei",
    },
    {
      label: "Insurance",
      url_slug: "insurance",
    },
    {
      label: "Technology",
      url_slug: "technology",
    },
    {
      label: "Gravitas News",
      url_slug: "gravitas-news",
    },
    {
      label: "Videos",
      url_slug: "videos",
    },
    {
      label: "Employers",
      url_slug: "employers",
    },
    {
      label: "Candidate",
      url_slug: "candidate",
    },
    {
      label: "Banking",
      url_slug: "banking",
    },
  ],
};

export const findTag = ({ value, key = "url_slug", locale = "en" } = {}) => {
  return tags[locale].find((i) => i[key] === value) ?? null;
};
